<template>
  <div class="container">
    <div
      id="page1-div"
      ref="document"
      class="container interline border page-container"
    >
      <div class="col-12 text-justify p-5">
        <div class="col-12  text-center">
          <span class="ft11Black"> <br />PAGARÉ<br /><br /> </span>
        </div>
        <div class="col-12 m-1">
          <span class="ft11">
            Por el presente pagaré,
            <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
              {{ data.nombre_cliente }}
            </span>
            <span v-if="data.tipoAmoral">
              por medio de su Representante legal
              <span class="ft11Black"
                v-bind:class="{ 'marca': data.showMarca }"
              >
                {{ data.reprecentante_legal }}
              </span>
              (enadelante el “DEUDOR SOLIDARIO”)
            </span>
            <span v-if="!data.tipoAmoral">
              (en adelante, el “DEUDOR / SUSCRIPTOR”)
            </span>
            <span
              v-if="data.tipoAbound || data.tipoAbout"
              class="ft11"
            >
              y/o
              <span
                class="ft11Black"
                v-bind:class="{ 'marca-obligado': data.showMarca }"
              >
                {{ data.nombre_obligado }}
              </span>
              (en adelante el “AVAL Y OBLIGADO SOLIDARIO”)
            </span>
            <span v-if="data.tipoAendorsement || data.tipoAbout" class="ft11">
              y/o
              <span
                class="ft11Black"
                v-bind:class="{ 'marca-aval': data.showMarca }"
              >
                {{ data.nombre_aval }}
              </span>
              (en adelante el “AVAL Y OBLIGADO SOLIDARIO”)
            </span>
            <span v-if="data.tipoAendorsement || data.tipoAbout  || data.tipoAmoral || data.tipoAbound" class="ft11">
              reconocemos deber y nos obligamos incondicionalmente a pagar a favor de
            </span>
            <span v-else class="ft11">
              reconozco deber y me obligo incondicionalmente a pagar a favor de
            </span>
            <span class="ft11Black">
              GPI AUTO COMERCIAL SAPI DE C.V.
            </span>
            la cantidad de
            <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
              ${{ data.precio_seguro }}
              {{ data.precio_seguro_letra }},
            </span>
            en el domicilio
            <span class="ft11Black"
              v-if="data.estado_cliente != 'CIUDAD DE MÉXICO'
                    && data.estado_cliente != 'ESTADO DE MÉXICO'"
              v-bind:class="{ marca: data.showMarca }">
              Avenida de Las Rosas 2991, Colonia Chapalita,
              Guadalajara, Jalisco 44510.
            </span>
            <span class="ft11Black"
              v-if="data.estado_cliente == 'CIUDAD DE MÉXICO' || data.estado_cliente == 'ESTADO DE MÉXICO'"
              v-bind:class="{ marca: data.showMarca }">
              Av.Nuevo leon 253, despacho 802, Colonia Escandon, Miguel Hidalgo, CDMZ CP 11800.
            </span>
              El importe del presente pagaré será liquidado por el DEUDOR / SUSCRIPTOR en una sola exhibición el día
            <span class="ft11Black" v-bind:class="{ marca: data.showMarca }">
              {{fecha}}.
            </span>
            <br />
            <br />
          </span>
          <span class="ft11">
            La falta oportuna y completa de pago generará un interés moratorio a
            razón del 8% (ocho por ciento) mensual sobre la suerte principal
            mencionada en el párrafo anterior y se continuará generando hasta en
            tanto no haya sido totalmente liquidada dicha cantidad.
          </span>
          <br />
          <br />
          <span class="ft11">
            Cualquier pago efectuado por el Deudor, será aplicado por el
            Acreedor, para cubrir, en primer lugar y hasta donde alcance, el
            saldo insoluto de los intereses moratorios de que se trate, en caso
            de que exista y, hasta donde alcance, el saldo insoluto del importe
            del presente pagaré de que se trate, así como cualquier otro importe
            que le corresponda pagar al Deudor
          </span>
          <br />
          <br />
          <span class="ft11">
            Este pagare es mercantil y está regido por la Ley General de Títulos
            y Operaciones de Crédito en su artículo 170 y demás disposiciones
            aplicables a la materia mercantil.
          </span>
          <br />
          <br />
          <span class="ft11">
            El Deudor y/o el Obligado Solidario, en forma expresa, desde ahora:
            (i) autorizan al Acreedor y/o a cualquier tenedor subsecuente (en
            adelante, el “Tenedor”), para que endose(n) y/o transmita(n) y/o
            descuente(n) y/o transfiera(n) y/o ceda(n) y/o negocie(n) y/o
            afecte(n) y/o grave(n) este pagaré y los derechos de crédito que
            ampara, en cualquier tiempo y lugar, sirviendo el presente como la
            más amplia y necesaria autorización del Deudor y/o Obligado
            Solidario al respecto; (ii) renuncian expresamente a lo establecido
            en el segundo párrafo del artículo 299 de la Ley General de Títulos
            y Operaciones de Crédito; (iii) amplían el plazo de presentación de
            este pagaré, para que su pago pueda efectuarse dentro del plazo de
            un año posterior a la fecha del pago previsto; y, (iv) autorizan al
            Acreedor y/o al Tenedor para que, en caso de que el Deudor y/o
            Obligado Solidario omitan liquidar cantidad o cantidades pactadas en
            el presente pagaré, en la fecha de pago de que se trate, pueda(n)
            dar válidamente por vencido anticipadamente el plazo establecido en
            el presente pagaré y, por lo tanto, el Deudor y/o Obligado Solidario
            estarán obligados a pagar al Acreedor y/o al Tenedor, el saldo
            insoluto pendiente de pago.
          </span>
          <br /><br />
          <span class="ft11">
            El Deudor, señala como domicilio para recibir cualquier
            emplazamiento y/o notificación legal al respecto del pagaré los
            siguientes:
          </span>
          <br /><br />
          <span class="ft11Black">
            El DEUDOR / SUSCRIPTOR
          </span>
          <span class="ft11">
            señala como domicilio para recibir cualquier
            emplazamiento y/o notificación legal al respecto del pagaré los
            siguientes:
            <span  class="ft11" v-bind:class="{ marca: data.showMarca }">
              CALLE {{ data.calle_cliente }}, NO.
              {{ data.numero_calle_cliente }}
              {{ data.colonia_cliente }}, CODIGO POSTAL
              {{ data.codigo_postal_cliente }}, DE LA POBLACION DE
              {{ data.colonia_cliente }}, MUNICIPIO DE
              {{ data.municipio_cliente }}, {{ data.estado_cliente }}.
            </span>
          </span>
            <br /><br />
          <span v-if="data.tipoAbound" class="ft11">
            <span class="ft11Black">
              AVAL Y OBLIGADO SOLIDARIO:
            </span>
            <span v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.calle_obligado }}
              No. {{ data.numero_calle_obligado }},
              {{ data.colonia_obligado }}
              {{ data.municipio_obligado }}, {{ data.estado_obligado }},
              {{ data.codigo_postal_obligado }}.
            </span>
            <br /><br />
          </span>
          <span v-if="data.tipoAendorsement" class="ft11">
            <span class="ft11Black">
              AVAL Y OBLIGADO SOLIDARIO:
            </span>
            <span v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.calle_aval }}
              No. {{ data.numero_calle_aval }}, {{ data.colonia_aval }},
              {{ data.municipio_aval }}, {{ data.estado_aval }},
              {{ data.codigo_postal_aval }}.
            </span>
            <br /><br />
          </span>

          <span class="ft11">
            El presente pagare consta de 1 página y para toda controversia o
            litigio de cualquier tipo en relación con el presente pagaré, el
            deudor y/o el/los obligado Solidario están de acuerdo en someterse
            de manera expresa a la jurisdicción de los Tribunales competentes de
            la delegación o municipio que elija la parte actora, ya sea respecto
            a los domicilios indicados anteriormente, o los tribunales de la Cd.
            De México.<br /><br />
          </span>

          <v-firmasPagares v-bind:data="data"></v-firmasPagares>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firmasPagares from "./firmasPagares.vue";
export default {
  name: "pago-seguros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  components: {
    "v-firmasPagares": firmasPagares,
  },
  props: {
    data: {
      type: Object
    },
    fecha: String
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");

    }
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/contratoArrendamiento/pagare/Pagare_valor_seguros.vue